(() => {
  const selector = '#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container';
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 767.98px)');
  let launcher;
  let frame;

  const ensureFilterSvg = () => {
    if (document.getElementById('au-floating-widget-filters') || !document.body) return;
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.id = 'au-floating-widget-filters';
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
    // Remap Smile's native #b59960 background / white icon to the theme's
    // warm #c8952d gold / white icon. Filter only the launcher, not its panel.
    svg.innerHTML =
      '<defs><filter id="au-smile-recolor" color-interpolation-filters="sRGB">' +
      '<feColorMatrix type="matrix" values="-0.647058824 0 0.647058824 0 1 -1.247058824 0 1.247058824 0 1 -2.470588235 0 2.470588235 0 1 0 0 0 1 0"/>' +
      '</filter></defs>';
    document.body.appendChild(svg);
  };

  const measure = () => {
    frame = null;
    ensureFilterSvg();
    const nextLauncher = document.querySelector(selector);
    if (nextLauncher !== launcher) {
      if (launcher) resizeObserver.unobserve(launcher);
      launcher = nextLauncher;
      if (launcher) resizeObserver.observe(launcher);
    }

    const width = launcher ? launcher.offsetWidth : 0;
    const height = launcher ? launcher.offsetHeight : 0;
    const targetSize = parseFloat(getComputedStyle(document.body).getPropertyValue('--au-widget-size')) || 48;
    const scale = height > targetSize ? targetSize / height : 1;
    // The iframe's width depends on its text, device mode and SDK lifecycle.
    root.style.setProperty('--au-rewards-slot', `${width ? width * scale + 12 : 0}px`);
    root.style.setProperty('--au-rewards-height', `${height * scale}px`);
    root.style.setProperty('--au-rewards-scale', `${scale}`);
  };

  const scheduleMeasure = () => {
    if (!frame) frame = requestAnimationFrame(measure);
  };

  const resizeObserver = new ResizeObserver(scheduleMeasure);
  const mutationObserver = new MutationObserver((records) => {
    const hasLauncherChange = records.some((record) =>
      [...record.addedNodes, ...record.removedNodes].some(
        (node) => node.nodeType === Node.ELEMENT_NODE && (node.matches(selector) || node.querySelector(selector))
      )
    );
    if (hasLauncherChange) scheduleMeasure();
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });
  mobile.addEventListener('change', scheduleMeasure);
  measure();

  window.addEventListener('pagehide', (event) => {
    if (event.persisted) return;
    mutationObserver.disconnect();
    resizeObserver.disconnect();
    mobile.removeEventListener('change', scheduleMeasure);
    if (frame) cancelAnimationFrame(frame);
  });
})();
